/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Architect_Output9Inputs */

const en_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App architecture diagram`)
};

const ar_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخطط معمارية التطبيق`)
};

const bn_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপ আর্কিটেকচার ডায়াগ্রাম`)
};

const de_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Architekturdiagramm`)
};

const es_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrama de arquitectura de la aplicación`)
};

const fr_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schéma d'architecture de l'application`)
};

const pt_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrama de arquitetura do aplicativo`)
};

const zh_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用架构图`)
};

const tr_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama mimarisi diyagramı`)
};

const ru_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схема архитектуры приложения`)
};

const pl_svc_mobile_app_development_architect_output9 = /** @type {(inputs: Svc_Mobile_App_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram architektury aplikacji`)
};

/**
* | output |
* | --- |
* | "App architecture diagram" |
*
* @param {Svc_Mobile_App_Development_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_architect_output9 = /** @type {((inputs?: Svc_Mobile_App_Development_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "de") return de_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "es") return es_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_architect_output9(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_architect_output9(inputs)
	return en_svc_mobile_app_development_architect_output9(inputs)
});
export { svc_mobile_app_development_architect_output9 as "svc_mobile-app-development_ARCHITECT_output" }